import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { VietQrBankDto, VietQrBankService } from 'src/app/core/services/vietqr-bank.service';

interface BankUpdatePayload {
  bankAccountName: string;
  bankName: string;
  bankBranch: string;
  bankAccountNumber: string;
  passwordBank?: string;
}

@Component({
  selector: 'app-bank-dialog',
  templateUrl: './bank-dialog.component.html',
  styleUrls: ['./bank-dialog.component.css']
})
export class BankDialogComponent implements OnChanges, OnDestroy {
  @Input() visible = false;
  @Input() userInfo: any = null;

  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<BankUpdatePayload>();

  draftBankAccountName = '';
  draftBankName = '';
  draftBankBranch = '';
  draftBankAccountNumber = '';
  draftpasswordBank = '';
  submitError = '';

  banksLoading = false;
  banks: VietQrBankDto[] = [];

  private banksSub?: Subscription;

  constructor(private bankService: VietQrBankService) {}

  get hasBankInfo(): boolean {
    return !!(this.userInfo?.bankName || this.userInfo?.bankAccountNumber || this.userInfo?.bankAccountName);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true || changes['userInfo']) {
      this.syncDraftFromUserInfo();
    }

    if (changes['visible']?.currentValue === true) {
      this.loadBanks();
    }
  }

  ngOnDestroy(): void {
    this.banksSub?.unsubscribe();
  }

  private loadBanks(): void {
    if (this.banksLoading || this.banks.length) return;
    this.banksLoading = true;

    this.banksSub?.unsubscribe();
    this.banksSub = this.bankService.getBanks().subscribe({
      next: (banks) => {
        this.banks = Array.isArray(banks) ? banks : [];
        this.banksLoading = false;
        this.tryNormalizeDraftBankName();
      },
      error: () => {
        this.banks = [];
        this.banksLoading = false;
      },
    });
  }

  private tryNormalizeDraftBankName(): void {
    const current = this.normalizeText(this.draftBankName);
    if (!current || !this.banks.length) return;

    const direct = this.banks.find((b) => b.shortName === current);
    if (direct) return;

    const byName = this.banks.find((b) => this.normalizeText(b.name) === current || this.normalizeText(b.shortName) === current);
    if (byName) this.draftBankName = byName.shortName;
  }

  close(): void {
    this.submitError = '';
    this.closed.emit();
  }

  save(): void {
    const payload: BankUpdatePayload = {
      bankAccountName: this.normalizeText(this.draftBankAccountName),
      bankName: this.normalizeText(this.draftBankName),
      bankBranch: this.normalizeText(this.draftBankBranch),
      bankAccountNumber: this.normalizeDigits(this.draftBankAccountNumber),
      passwordBank: this.normalizeText(this.draftpasswordBank)
    };

    if (!payload.bankAccountName || !payload.bankName || !payload.bankAccountNumber) {
      this.submitError = 'Vui lòng nhập đầy đủ tên chủ tài khoản, tên ngân hàng và số tài khoản.';
      return;
    }

    this.submitError = '';
    this.submitted.emit(payload);
  }

  get currentBalanceDisplay(): string {
    const raw = Number(this.userInfo?.balence ?? this.userInfo?.balance ?? 0);
    return new Intl.NumberFormat('vi-VN').format(raw > 0 ? raw : 0);
  }

  private syncDraftFromUserInfo(): void {
    this.submitError = '';
    this.draftBankAccountName = this.userInfo?.bankAccountName || '';
    this.draftBankName = this.userInfo?.bankName || '';
    this.draftBankBranch = this.userInfo?.bankBranch || '';
    this.draftBankAccountNumber = this.normalizeDigits(this.userInfo?.bankAccountNumber || '');
    this.draftpasswordBank = '';

    this.tryNormalizeDraftBankName();
  }

  private normalizeText(value: string): string {
    return String(value || '').trim();
  }

  private normalizeDigits(value: string): string {
    return String(value || '').replace(/\D/g, '').slice(0, 12);
  }
}
